import { render, staticRenderFns } from "./SeveritiesBtns.vue?vue&type=template&id=e1aad6c8&scoped=true&"
import script from "./SeveritiesBtns.vue?vue&type=script&lang=ts&"
export * from "./SeveritiesBtns.vue?vue&type=script&lang=ts&"
import style0 from "./SeveritiesBtns.vue?vue&type=style&index=0&id=e1aad6c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1aad6c8",
  null
  
)

export default component.exports